/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var OftenSearchedLinkBox = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,

		on: function(callback) {
			callback();
		},

		after: function() {
			this.findElements();
		},

		initSearch: function(searchContainer) {
			this.searchContainer = searchContainer;
		},

		findElements: function() {
			var mod = this;
			mod.$links = this.$ctx.find('.scs-sitesearch-oftensearchedbox-list-item > a');
			mod.$links.each(function() {
				var $link = $(this);
				$link.click(function() {
					// Force the session to increase for the next request
					mod.searchContainer.sessionOptions.forceOnce = 'next';
					// Track clicks.
					Module.SearchResultContainer.trackClick(
						'often',
						{},
						{
							url: $link.prop('href'),
							query: $link.attr('data-sitesearch-query')
						},
						// We don’t have a search processor instance so just use the prototype as it has the same methods.
						SCS.search.Processor.prototype
					);
				});
			});
		}

	});

	Module.OftenSearchedLinkBox = OftenSearchedLinkBox;

})(window.Tc.Module, window.Tc.$, window.SCS = window.SCS || {});

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.OftenSearchedLinkBox.js
// module id = 55
// module chunks = 0